// module imports
import $ from "jquery";

//
// Main
//

//
// Header
document.addEventListener("DOMContentLoaded", function () {
  // Zugriff auf das Hamburger-Menü und das Vollbild-Navigationselement
  var hamburgerMenuWrap = document.querySelector(".hamburger_wrap");
  var fullscreenNav = document.getElementById("fullscreenNav");
  var logo = document.querySelector("#logo");

  // Funktion zum Umschalten der Vollbild-Navigation
  function toggleFullscreenNav() {
    // Überprüfen, ob das Vollbild-Navigationselement sichtbar ist
    var isNavVisible = fullscreenNav.style.top === "6px";

    // Wenn das Vollbild-Navigationselement sichtbar ist, verstecken wir es
    // Wenn es nicht sichtbar ist, zeigen wir es an
    fullscreenNav.style.top = isNavVisible ? "-100%" : "6px";

    // Scrollen Sie zuerst nach oben
    window.scrollTo(0, 0);
    // Scrollen verhindern, wenn das Menü geöffnet ist
    document.body.style.overflow = isNavVisible ? "auto" : "hidden";
    // Add is-active to hamburger menu
    var hamburgerMenu = document.querySelector(".hamburger");
    hamburgerMenu.classList.toggle("is-active");
    hamburgerMenuWrap.classList.toggle("is-active");

    // Überprüfen Sie den Inhalt von logo.src
    $filename = logo.src.split("/").pop();

    if (hamburgerMenu.classList.contains("nohero")) {
      if ($filename === "logo_weiss.svg") {
        newLogoSrc = "/wp-content/themes/energiekonzeptai/assets/img/logo_farbig.svg";
        logo.src = newLogoSrc;
      } else {
        newLogoSrc = "/wp-content/themes/energiekonzeptai/assets/img/logo_weiss.svg";
        logo.src = newLogoSrc;
      }
    }
  }
  // Binden der Funktion toggleFullscreenNav an das Klickereignis des Hamburger-Menüs
  hamburgerMenuWrap.addEventListener("click", toggleFullscreenNav);

  // Logo Farbig wenn kein Hero vorhanden
  if (!document.querySelector(".hero")) {
    // Logo-Element auswählen

    // Pfad zum neuen Logo
    var newLogoSrc = "/wp-content/themes/energiekonzeptai/assets/img/logo_farbig.svg";
    // Logo ändern
    logo.src = newLogoSrc;
    var hamburger = document.querySelector(".hamburger");
    hamburger.classList.toggle("nohero");
    var hamburgerMenuWrap = document.querySelector(".hamburger_wrap");
    hamburgerMenuWrap.classList.toggle("nohero");
  }
});

function handleNavItemClick(navItem, navItems) {
  // Remove active class from all menu items
  navItems.forEach(function (item) {
    if (item !== navItem) {
      // Do not remove 'active' class from the current item
      item.classList.remove("active");
    }
  });

  // Add active class to the clicked menu item
  navItem.classList.add("active");

  var submenu = navItem.querySelector(".sub-menu");
  var submenuContainer = document.getElementById("submenuContainer");
  submenuContainer.innerHTML = submenu.outerHTML;
}

document.addEventListener("DOMContentLoaded", function () {
  var navItems = document.querySelectorAll(".nav > li");
  var currentPath = window.location.pathname;

  navItems.forEach(function (navItem) {
    var subMenuItems = navItem.querySelectorAll(".sub-menu > li");

    subMenuItems.forEach(function (subMenuItem) {
      var subMenuItemPath = subMenuItem.querySelector("a").getAttribute("href");

      // Entfernen Sie den Domain-Teil der URL, wenn vorhanden
      subMenuItemPath = subMenuItemPath.split("/");
      subMenuItemPath = "/" + subMenuItemPath.slice(-2).join("/");

      // Überprüfen Sie, ob der Pfad des Untermenüelements dem aktuellen Pfad entspricht
      if (subMenuItemPath === currentPath) {
        // Markieren Sie das Untermenüelement und das übergeordnete Menüelement als aktiv
        subMenuItem.classList.add("active");
        navItem.classList.add("active");

        // Führen Sie den Code aus, der normalerweise im click-Event-Handler ausgeführt wird
        handleNavItemClick(navItem, navItems);
      }
    });

    navItem.addEventListener("click", function () {
      handleNavItemClick(this, navItems);
    });
  });
});
//Mobile Menu Show
document.addEventListener("DOMContentLoaded", function () {
  if (window.matchMedia("(max-width: 782px)").matches) {
    document.querySelectorAll(".menu-item-has-children > ul").forEach(function (subMenu) {
      subMenu.style.display = "none";
      var menuItem = subMenu.parentNode;
      menuItem.classList.add("has-submenu");

      // Erstellt ein neues Span-Element für den Pfeil
      var arrowSpan = document.createElement("span");
      arrowSpan.classList.add("submenu-arrow");
      arrowSpan.style.marginLeft = "6px";
      arrowSpan.style.content =
        "url('/wp-content/themes/energiekonzeptai/assets/img/arrow_down.svg')";

      // Fügt das Span-Element direkt nach dem Link innerhalb des Menüelements hinzu
      var linkElement = menuItem.querySelector("a");
      if (linkElement) {
        linkElement.after(arrowSpan);
      }
      console.log(menuItem);
      // Optional: Toggle für das Anzeigen/Verstecken des Untermenüs beim Klicken auf den Pfeil
      menuItem.addEventListener("click", function (event) {
        event.stopPropagation(); // Verhindert das Auslösen des Eltern-Event-Listeners
        if (subMenu.style.display === "none") {
          subMenu.style.display = "block";
        } else {
          subMenu.style.display = "none";
        }
      });

      // // Verhindert, dass der Link-Click das Untermenü toggelt
      // linkElement.addEventListener("click", function (event) {
      //   event.stopPropagation(); // Verhindert, dass der Klick-Event nach oben im DOM weitergeleitet wird
      // });
    });
  }
});

// Referenzen Slider
//
// REFERENZEN ÜBERSCHRIFT
document.addEventListener("DOMContentLoaded", function () {
  var filterButtons = document.querySelectorAll(".filter_btn");

  if (filterButtons.length === 0) {
    return;
  }

  filterButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      // Entfernen der 'active' Klasse von allen Buttons
      filterButtons.forEach(function (button) {
        button.classList.remove("active");
      });

      // Hinzufügen der 'active' Klasse zum geklickten Button
      this.classList.add("active");

      var filter = this.getAttribute("data-filter");
      var cards = document.querySelectorAll(".referenz_card");

      if (cards.length === 0) {
        return;
      }

      cards.forEach(function (card) {
        if (filter === "" || filter === "alle") {
          card.style.display = "";
        } else {
          if (card.classList.contains(filter)) {
            card.style.display = "";
          } else {
            card.style.display = "none";
          }
        }
      });
    });
  });

  // Optional: Markieren Sie den "Alle" Button als aktiv beim Laden der Seite
  var alleButton = document.querySelector('.filter_btn[data-filter=""]');
  if (alleButton) {
    alleButton.classList.add("active");
  }
});

// COUNTER
document.addEventListener("DOMContentLoaded", (event) => {
  const counters = document.querySelectorAll(".zaehler");
  const speed = 500; // The higher the slower

  const updateCount = (counter) => {
    const target = +counter.getAttribute("data-target");
    const count = +counter.innerText;
    const inc = target / speed;

    if (count < target) {
      counter.innerText = Math.ceil(count + inc);
      setTimeout(() => updateCount(counter), 1);
    } else {
      counter.innerText = target;
    }
  };

  const checkScroll = () => {
    counters.forEach((counter) => {
      const rect = counter.getBoundingClientRect();
      if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
        updateCount(counter);
      }
    });
  };

  window.addEventListener("scroll", checkScroll);
  checkScroll();
});

// TEAM

// Hover Bild Effekt
document.addEventListener("DOMContentLoaded", function () {
  // Auswahl aller Elemente mit der Klasse .team-image
  var teamImages = document.querySelectorAll(".team-image");

  // Durchlaufen aller .team-image Elemente
  teamImages.forEach(function (teamImage) {
    // Speichern der ursprünglichen und der Hover-Bild-URLs
    var originalImage = teamImage.style.backgroundImage;
    var hoverImage = "url(" + teamImage.getAttribute("data-hover-image") + ")";

    // Event-Listener für Mouseover
    teamImage.addEventListener("mouseover", function () {
      teamImage.style.backgroundImage = hoverImage;
    });

    // Event-Listener für Mouseout
    teamImage.addEventListener("mouseout", function () {
      teamImage.style.backgroundImage = originalImage;
    });
  });
});

// <hr>-Tag Animation
document.addEventListener("DOMContentLoaded", function () {
  const hrElements = document.querySelectorAll(".hr-animated");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("start-animation");
        observer.unobserve(entry.target);
      }
    });
  });

  hrElements.forEach((hrElement) => {
    observer.observe(hrElement);
  });
});
